import React, { useMemo } from 'react';
import uuid from 'uuid/v4';
import { cloneDeep } from 'lodash';
import CellContent from './CellContent';
import { getProcessedFilter, setHeightOfRows } from '../../../util/CrosstabUtils';

function CrosstabViewCellContent({ cellElementList, getGridRows, colEndIndex,
    highlightAndFilter, toggleCheckVal, handleProbabilitiesEditClick, partsToShow }) {

    const metricsList = cellElementList.map(item => { return item.isVisible; });
    const metricsCount = cellElementList.filter(item => item.isVisible);
    const newRows = cloneDeep(getGridRows);

    return useMemo(() => newRows.map((newRow, index) =>
      (<div key={uuid()} className="c-table--row" 
      style={{ height: setHeightOfRows(partsToShow, newRow, index, toggleCheckVal, 'Crosstab-View', metricsList) }}>
        {newRow.cellList.slice(0, colEndIndex).map(col => (<div key={uuid()} className="c-table-crosstab-col">
          <CellContent
            crosstabviewFlag
            cell={col}
            metricsCount={metricsCount.length}
            highlightAndFilter={highlightAndFilter}
            metricsList={metricsList}
            newHighlightAndFilter={getProcessedFilter(highlightAndFilter)}
            cellHeight={setHeightOfRows(partsToShow, newRow, index, toggleCheckVal, 'Crosstab-View', metricsList)}
            handleProbabilitiesEditClick={handleProbabilitiesEditClick}
          />
        </div>))
        }
      </div>)
    ), [newRows, cellElementList, highlightAndFilter, toggleCheckVal.row, colEndIndex]);
  };

  
export default React.memo(CrosstabViewCellContent);
